import React, { Fragment } from 'react';

import {
    customHeaderStyle, defaultPaginationOptions,
    defaultTableHeaderStyles,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle,
} from "root/Tables/BaseTableComponents";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import { decodeStringForPost } from "root/DataFunctions/BaseDataFns";
import RAGStatus from "root/ReactHookForm/ui/ReactRAGStatus";

const TableProviderRAGReport = (props ) =>
{
    const composeRef = (record) =>
    {
        const hasRef = record.section_ref !== null && record.question_ref !== null ;

        const refText = hasRef ? record.section_ref + '.' + record.question_ref + '. ' : '' ;

        return refText ;
    }

    const composeSectionRef = (record) =>
    {
        const hasRef = record.section_ref !== null ;

        const refText = hasRef ? record.section_ref + '. ' : '' ;

        return refText ;
    }

    const summaryFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const rval = row.summary_text === null ? composeRef(row) + row.question_text : composeRef(row) + row.summary_text ;

        return rval ;
    }
    const standardFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const rval = composeSectionRef(row) + row.table_section_name  ;

        return rval ;
    }

    const actionFormatter = (cell, row, rowIndex, formatExtraData) => {

        return decodeStringForPost( row.action ) ;
    }

    const statusFormatter = (cell, row, rowIndex, formatExtraData) => {

        return  <RAGStatus
            value={+(row.status)}
        />
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: {...defaultTableHeaderStyles, fontSize: '16px'},
        table_section_name: {borderRadius: defaultTopLeftCellStyle, width: "6vw"},
        status: {width: "5vw", textAlign: 'center'},
        summary_text:{width: "24vw"},
        action: {width: "24vw" },
        pdf: {borderRadius: defaultTopRightCellStyle, width: "2vw", textAlign: 'center'}
    });

    const getColumns = () =>
    {
        let columns = [];

        columns.push({
            dataField: 'table_section_name',
            text: 'Standard',
            formatter: standardFormatter,
            sort: true,
            headerStyle: headerStyle
        });

        columns.push({
            dataField: 'status',
            text: 'Status',
            sort: true,
            formatter: statusFormatter,
            headerStyle: headerStyle
        });

        columns.push({
            dataField: 'summary_text',
            text: 'Statement',
            sort: true,
            formatter: summaryFormatter,
            headerStyle: headerStyle
        });

        columns.push({
            dataField: 'action',
            text: 'Action',
            formatter: actionFormatter,
            headerStyle: headerStyle
        });

        return columns;
    }

    const translations = xlateBootstrapTableColumns(getColumns());

    const columns = React.useMemo(() => translations, []);

    const tableContent = () =>
    {
        return <PassportTable data={props.data.data} isLoading={props.data.loading} columns={columns} pagination={defaultPaginationOptions} showSearch={true}/>
    }

    return props.data.loading === true ? <SpinnerDiv/> : tableContent();
}

export default TableProviderRAGReport;
